import { Component, Inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-enter-email-modal',
  templateUrl: './enter-email-modal.component.html',
  styleUrls: ['./enter-email-modal.component.scss'],
})
export class EnterEmailModalComponent {
  formGroup: UntypedFormGroup;

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EnterEmailModalComponent>,
    private api: OrderApiService,
    private message: MessageService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.formGroup = this.fb.group({
      user_name: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      one_code: ['', []],
      two_code: ['', []],
    });
  }

  loading = false;
  async onOk() {
    if (!this.formGroup.value.user_name) {
      this.message.warn('请正确填写邮箱', { position: 'top' });
      return;
    }
    if (!this.formGroup.value.password) {
      this.message.warn('请填写密码', { position: 'top' });
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.enterYoutubeEmail(
        this.data.id,
        this.formGroup.value.user_name,
        this.formGroup.value.password,
        this.formGroup.value.one_code,
        this.formGroup.value.two_code
      );
      if (r.status === 0) {
        this.message.open('提交成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
